import { PRODUCT_CONFIG } from "ProductConfig";

export const PUBLIC_ROUTES = [
  new RegExp(`^/(${Object.keys(PRODUCT_CONFIG).join("|")})/try-product$`),
  new RegExp(`^/(${Object.keys(PRODUCT_CONFIG).join("|")})/agent-download/.+$`),
];